import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';

export class destinationSearch {
	private $scope = $('.destionation-search');

  seachExplore(): void{
	let _self = this;
		let $destinationCountry: any = _self.$scope.find('.destCountry');
		let $destinationCity: any = _self.$scope.find('.destCity');
  }

  dealSelector(): void {
		let _self = this;
		let $countryselectorContainer: any = _self.$scope.find('.destination-city--selector');
		let $countryselector: any          = _self.$scope.find('.destCountry');

		let countryData:any;
		let defaultCountry:any;

		let countrySelector:any = $countryselectorContainer.find('.destCountry');
		let citySelector:any    = $countryselectorContainer.find('.destCity');

		/**
		 * initialize country/language selectors
		 *
		 * trigger after retrieving dataset
		 */
		getCountrySelData().done((res:any) => {
			if (typeof res === 'string') {
				res = JSON.parse(res);
			}
			countryData    = cleanCountryData(res.countrysList);
			defaultCountry = getDefaultCountry(countryData);
			initCitySelector(countryData);
			initCountrySelector(countryData);
		});


		/**
		 * Get country data by ajax
		 * @param {any} callback [callback fn]
		 */
		 function getCountrySelData(){
			let defer = $.Deferred();
			let dataUrl:string = _self.$scope.attr('data-get-url');

			$.get(dataUrl, {pagelink: $('#pageLink').val()})
				.done((data:any) => {
					defer.resolve(data);
				})
				.fail((error:any) => {
					defer.reject(error);
				});

				return defer.promise();
		 }

		/**
		 * format country data
		 * consolidate all countries irregardless of region
		 * @param {any} data [input data - country array]
		 * @return {any} [countries object]
		 */
		function cleanCountryData(data:any) {
			let countries:any         = [];
			let countriesIndex:number = 0;

			// consolidate all countries irregardless of region
			for (var i=0, len=data.length; i<len; i++) { // loop thru region
				for (var j=0, jlen=data[i].countries.length; j<jlen; j++) { // loop thru countries
					countries[countriesIndex] = {
						name:      data[i].countries[j].countryName,
						region:    data[i].regionName,
						cityname: data[i].countries[j].cityname
					};
				countriesIndex++;
				}
			}

			return countries;
		}

		/**
		 * get default country from dataset
		 *
		 * IMPT: function assumes dataset values in html
		 * for country and city are correct.
		 *
		 * @param {any} countries [country dataset]
		 */
		function getDefaultCountry(countries:any) {
			// todo: determine default Ciry and set it
			// for now just use the first City in the dataset
			// to demo

			var onloadCountry:any = $countryselector;
			var onloadCityname:any = getCountryCityname(onloadCountry[0].dataset.country, countries);
			return {
				name: onloadCountry[0].dataset.country,
				cityname: onloadCityname,
				selectedCityname: onloadCountry[0].dataset.cityname,
				abbr: onloadCountry[0].dataset.abbr
			};
		}

		/**
		 * match city to selected country
		 * @param {string} name      [selected country]
		 * @param {any}    countries [country dataset]
		 * @return {any} [city object]
		 */
		function getCountryCityname(name:string, countries:any) {
			var cityname:any = [];

			// find city of selected country
			for (var i=0, len=countries.length; i<len; i++) {
				if (countries[i].name === name) {
					cityname = countries[i].cityname;
					break;
				}
			}

			if (cityname.length) {
				return cityname;
			} else {
				return false;
			}
		}
		/**
		 * match selected city in city object to get
		 * matching url value.
		 * @param {string} selectedCity [selected city]
		 * @param {any}    city        [city object]
		 * @return {string} [city site url]
		 */
		function getCitynameUrl(selectedCityname:string, cityname:any) {
			let cityUrl:string;
			for (var i=0, len=cityname.length; i<len; i++) {
				if (cityname[i].name === selectedCityname) {
					cityUrl = cityname[i].url;
					break;
				}
			}
			return cityUrl;
		}

		/**
		 * initialize countrySelector element
		 * @param {any} countries [country dataset]
		 */
		function initCountrySelector(countries:any){

			 let $destCountry: any = _self.$scope.find('.selectDestCountry');
			 let $destCity: any = _self.$scope.find('.selectDestCity');
			countrySelector.selectize({
				valueField:  'name',
				labelField:  'name',
				searchField: ['name', 'region'],
				options: countries,
				create: false,
				selectOnTab: true,
				onInitialize: function() {
					/**
					 * Set default value of country selector on initializing
					 */
					this.setValue(defaultCountry.name);
					countrySelector[0].selectize.$control_input.attr('readonly', 'readonly');
				},
				onFocus: function() {},
				onChange: function(value:any) {
					$destCountry.find('.booking-form--title').addClass('input-filled');
					$destCountry.find('.selectize-control.single .selectize-input').addClass('select-filled');
					$destCity.find('.booking-form--title').addClass('input-filled');
					$destCity.find('.selectize-control.single .selectize-input').addClass('select-filled');
					// console.log('changeval', value);
					/**
					 * detect change in country selector and set value to lang selector
					 * based on current value after change
					 */
					let langSelectize:any = citySelector[0].selectize;

					if (langSelectize) {
						let cityname:any = getCountryCityname(value, countries);

						if (cityname[0]) {
							// replace language selector with new options
							langSelectize.clear();
							langSelectize.clearOptions();
							langSelectize.addOption(cityname);
							langSelectize.refreshOptions(false);

							// show currently selected country if
							// country selected is equals to currently used language
							if (defaultCountry.name === value) {
								let defaultLangUrl:string = getCitynameUrl(defaultCountry.selectedCityname, defaultCountry.cityname);

								//langSelectize.setValue(defaultLangUrl);
							} else {
								langSelectize.setValue(cityname[0].url); // use first value of languages as default
							}
						}
					}

				},
				onBlur: function() {}
			});
		}

		/**
		 * initialize language selector element
		 * @param {any} countries [country dataset]
		 */
		function initCitySelector(countries:any){
			citySelector.selectize({
				valueField: 'url',
				labelField: 'name',
				searchField: ['name'],
				selectOnTab: true,
				onInitialize: function() {
					/**
					 * Set default value of country selector on initializing
					 */
					let defaultLangUrl:string = getCitynameUrl(defaultCountry.selectedCityname, defaultCountry.cityname);
					citySelector[0].selectize.$control_input.attr('readonly', 'readonly');
				}
			});
		}
	}

	/**
	 * update search href value on change select value
	 */
	selectDestCityChangeHandler():void {
		let _self = this;
		let dealsSearch:any = $(document.getElementById("deals-search"));
		let destCitySelect:any = _self.$scope.find('select[name="selectDestCity"]');

		destCitySelect.on('change', function(){
			dealsSearch.attr({
				href: $(this).val()
			});
		});
	}

}

let scope:Element = document.querySelector('.destionation-search');
if (scope){
	try {
		let destinationsearch = new destinationSearch();
		// destinationsearch.seachExplore();
		$(document).ready(function(){
			destinationsearch.selectDestCityChangeHandler();
			destinationsearch.dealSelector();
		});
	} catch(e) {console.error(e);}
}
